<div class="Loading" *ngIf="isShowLoading==true">
	<div class="loader"></div>
	<label class="loaderlabel">Please wait while Processing....</label>
</div>

<div class="wrapper">

	<label style="padding: 5px;">{{'Claim Status' | translate}}</label>
	<div class="row searchRow">


		<div class="col-lg-2 col-md-2 col-sm-12 col-xs-12">
			<label for="">{{'Insured IdNo' | translate}}</label>
			<input class="form-control" type="text" id="txtIquamaNo" name="InsuredIdNo" [(ngModel)]="objSearchReq.InsuredIdNo" #txtInsuredIdNo="ngModel">

		</div>

		<div class="col-lg-2 col-md-2 col-sm-12 col-xs-12" style="display: flex;justify-content: center;">
			<span>{{'Or' | translate}}</span>
		</div>

		<div class="col-lg-2 col-md-2 col-sm-12 col-xs-12">
			<label for="">{{'PolicyNo' | translate}}</label>
			<input class="form-control" type="text" id="txtPolicyNo" name="txtPolicyNo" [(ngModel)]="objSearchReq.PolicyNo" #txtPolicynoo="ngModel">
		</div>

		<div class="col-lg-2 col-md-2 col-sm-12 col-xs-12" style="display: flex;justify-content: center;">
			<span>{{'Or' | translate}}</span>
		</div>

		<div class="col-lg-2 col-md-2 col-sm-12 col-xs-12">
			<label for="">{{'SequenceNo' | translate}}</label>
			<input class="form-control" type="text" id="txtSequenceNo" name="txtSequenceNo" [(ngModel)]="objSearchReq.SequenceNo" #txtSequenceNo="ngModel">
		</div>

		<div class="col-lg-2 col-md-2 col-sm-12 col-xs-12">
			<label for="">{{""}}</label>
			<button class="btn btn-primary" style="margin-top: 25px;" (click)="GetCalimStatus()">{{'Search Claim'|translate}}</button>
		</div>
	</div>



</div>

<!-- Claim status Start -->
<div class="overlay" *ngIf="ShowClaimStatus">
	<div class="popup">
		<div class="modalcard">
			<p class="modaltitle">{{'Claim Status'|translate}}
				<span style="color: aliceblue;font-weight: 500;cursor: pointer;" (click)="HideClaimStatus()">X</span>
			</p>


			<table class="table table-hover" id="PolicyList">
				<thead style=" color: black;">
					<tr>
						<th scope="col">{{'Sno'| translate}}</th>
						<th scope="col">{{'ClaimNo'|translate}}</th>
						<th scope="col">{{'Action'|translate}}</th>
					</tr>
				</thead>
				<tbody>
					<tr *ngFor="let obj of ClaimStatusRes.ClaimNoList; index as i">
						<th scope="row">{{i+1}}</th>
						<td><a class="third after fw700" (click)="ShowClaimsStatus(obj)">{{obj.ClaimNumber}}</a></td>
						<td><a style="cursor: pointer;" data-toggle="tooltip" title="{{'View Claim'|translate}}" (click)="ShowClaimsStatus(obj)"><i class="fa fa-eye fa-lg"></i></a></td>
					</tr>
				</tbody>
			</table>



			<div class="cardcontent" style="width: 100%;" *ngIf="CurrentClaimStatus !=null && CurrentClaimStatus.length>0">

				<div class="wrapper" *ngIf="Lang=='en'">
					<ul class="StepProgressEnglish">
						<li class="StepProgressEnglish-item is-done" *ngFor="let obj of CurrentClaimStatus">
							<strong>{{obj.Status}}</strong>
							{{obj.StatusDesc}}
						</li>
					</ul>
				</div>

				<div class="wrapper" *ngIf="Lang=='ar'">
					<ul class="StepProgressArabic">
						<li class="StepProgressArabic-item is-done" *ngFor="let obj of CurrentClaimStatus">
							<strong>{{obj.Status}}</strong>
							{{obj.StatusDesc}}
						</li>
					</ul>
				</div>

			</div>

		</div>
	</div>
</div>
<!-- Claim status end -->


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Pages/ClaimStatus/ClaimStatus.html